import $ from 'jquery'
import { getFilterAction } from '../postgrid';


function initFilters() {

    var dp = $("#pub-datepicker");


    if ($("#pub-datepicker").length == 0) {
        return
    }

    var $datepicker = $("#pub-datepicker").datepicker({
        nextText: ">",
        prevText: "<",



        // showOn: "both",


        timeFormat: 'hh:mm tt z',
        // changeMonth: true,
        // changeYear: true,
        weekHeader: "Wk",
        dayNamesMin: ["", "", "", "", "", "", ""],
        showDay: false,
        firstDay: 1,
        // showAnim: 'slideDown',
        dateFormat: 'dd-mm-yy',

        // minDate: new Date(),
        onSelect: function (dateText) {
            var year, month, day;
            day = dateText.substring(0, 2);
            month = dateText.substring(3, 5);
            year = dateText.substring(6, 10);
            var now_utc = Date.UTC(year, month - 1, day);

            //console.log(year);
            //console.log(month);
            //console.log(day);
            // var now_utc = d.getUTCDate();

            // var isoDate = new Date(dateText).toISOString();

            //                 var now_utc =  Date.UTC(dateText);

            //console.log("Selected date: " + now_utc + "; input's current value: " + this.value);
            getFilterAction(now_utc, 'update_dates');
        },
        // onChangeMonthYear: function (input, inst) {
        //     // inst.dpDiv.css({
        //     //     marginTop: -input.offsetHeight + 'px',
        //     //     'width': input.offsetWidth + 'px'
        //     // });
        //     setTimeout(function () {
        //         $('#ui-datepicker-div').css({ "width": $('#pub-datepicker').outerWidth() });
        //     }, 0);
        // },
        beforeShow: function (input, inst) {
            inst.dpDiv.css({
                marginTop: -input.offsetHeight + 'px',
                // 'width': input.offsetWidth + 'px'
            });
            // setTimeout(function () {
            //     $('#ui-datepicker-div').css({ "width": $('#pub-datepicker').outerWidth() });
            // }, 0);
        }

    });


    $datepicker.datepicker('setDate', new Date());


    $datepicker.datepicker("option", "weekHeader", "Wk");
}


export default initFilters